import React, { Component } from "react";
import { Link } from "react-router-dom";
import TextField from "../component/TextField";
import FpgDisableIcon from "../icons/fpgdisableicon";
import FpgpublishIcon from "../icons/fpgpublishicon";
import PlusIcon from "../icons/plusicon";
import PopUpCustomAll from "../component/fpg/create/popUpCustomAll";
import Loader from "../component/loader";
//Service import
import service from "../services";
//Validation import
import SimpleReactValidator from "simple-react-validator";

// Editors
import { Editor } from "react-draft-wysiwyg";
import { EditorState, convertToRaw, ContentState } from "draft-js";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";

//Redux Connect
import { connect } from "react-redux";
import moment from "moment";
import TextEditor from "../component/TextEditor";
import isEqual from 'lodash/isEqual';
import cloneDeep from 'lodash/cloneDeep';
let sub;

const mapStateToProps = (state) => ({
  EmailListEditId: state.EmailListEditId,
});

// const mapDispatchToProps = (dispatch) => {
//   return bindActionCreators(ActCreators, dispatch);
// };
class ProductDetail extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loaderFlag: false,
      deleteFilm: false,
      publishFilm: false,
      disableFilm: false,
      onSale: false,
      onSoldOut: "",
      name: "",
      onSale: false,
      onSoldOut: "",
      summary: EditorState.createEmpty(),
      price: "",
      changeCategoryTitleName: false,
      getLastUpdated: "",
      discardPopup: false,
      fromEmail: "",
      localAppName: "",
      isEmailDetailEdited: false,
      initialData: null
    };
    this.validator = new SimpleReactValidator({ autoForceUpdate: this });
    this.apiserve = new service();
  }

  getCurrentFormData = () => {
    const normalizeDraftHtml = (editorState) => {
      if (!editorState || typeof editorState === "string") return "";
      const html = draftToHtml(convertToRaw(editorState.getCurrentContent()));
      return html === "<p></p>\n" || html === "<p></p>" ? "" : html;
    };

    const formData = {
      subject: this.state.subject || "",
      content: normalizeDraftHtml(this.state.summary),
      title: this.state.title || "",
      previewText: this.state.previewText || "",
      pixelURL: this.state.pixelURL || "",
      localAppName: this.state.localAppName || "",
      fromEmail: this.state.fromEmail || "",
      emailTitle: this.state.emailTitle || "",
      isEmailEnabled: !!this.state.isEmailEnabled,
    };

    if (this.state.requiredButtonTitle) {
      formData.buttonTitle = this.state.buttonTitle || "";
    }

    return cloneDeep(formData);
  };

  markEmailDetailEdited = () => {
    if (this.state.initialData) {
      const isDirty = !isEqual(this.state.initialData, this.getCurrentFormData());
      if (this.state.isEmailDetailEdited !== isDirty) {
        this.setState({ isEmailDetailEdited: isDirty });
      }
    }
  };

  updateState = (data, callback) => {
    this.setState(data, () => {
      this.markEmailDetailEdited();
      if (callback) callback();
    });
  };

  componentDidMount() {
    this.getAllProductEditListdetails();
    this.getProductEditListdetails();
    this.setState({
      loaderFlag: true,
    });
  }

  closeAdminUser = () => {
    this.setState({
      deleteFilm: false,
      publishFilm: false,
      disableFilm: false,
      discardPopup: false,
      onSale: false
    });
  };

  onInputChange = (e) => {
    const { name, value } = e.target;
    if (name !== 'fromEmail') {
      this.updateState({
        [name]: value,
      });
    } else {
      let fromEmail = value.trim();
      if (fromEmail.includes('@')) {
        fromEmail = fromEmail.split('@')[0] 
      } 
      this.updateState({ fromEmail});
    }
  };

  handleCheck = (e) => {
    const { name, checked } = e.target;
    this.updateState({
      [name]: checked
    })
  };

  getProductEditListdetails = () => {
    sub = this.apiserve.getevent().subscribe((response) => {
      switch (response.event) {
        case "email|getMailTemplate":

          if (this.state.summary) {
            const blocksFromHtml = htmlToDraft(response.data.content ? response.data.content : "");
            const { contentBlocks, entityMap } = blocksFromHtml;
            const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
            const summary = EditorState.createWithContent(contentState);
            this.setState({
              summary
            });
          }

          this.setState(
            {
              subject: response.data.subject,
              title: response.data.title,
              btnURL: response.data.buttonURL,
              pixelURL: response.data.pixelURL,
              buttonTitle: response.data.buttonTitle,
              requiredButtonTitle: response.data.requiredButtonTitle,
              identifier: response.data.identifier,
              requiredKeys: response.data.requiredKeys,
              previewText: response.data.previewText,
              localAppName: response.data.localAppName,
              fromEmail: response.data.fromEmail.split('@')[0] || "", // Extracting the part before '@' for display
              emailTitle: response?.data?.emailTitle ?? "",
            //   accessType: response.data.accessType,
              emailTitle: response.data.emailTitle,
              isEmailEnabled: response.data.isEmailEnabled,
              getLastUpdated: {
                updatedAt: response?.data?.updatedAt,
                updatedBy: {
                  fname: response?.data?.updatedBy?.fname,
                  lname: response?.data?.updatedBy?.lname
                }
              }
            },
            () => {
              this.setState({
                loaderFlag: false,
                initialData: this.getCurrentFormData(),
                isEmailDetailEdited: false
              });
            }
          );
          break;
        case "email|editMailTemplate":
          if (response.error === true) {
            this.setState({
              loaderFlag: false,
              errorMsg: true,
              errorMsgShow: response.data.error,
            });
          } else {
            this.setState({
              loaderFlag: false,
              initialData: this.getCurrentFormData(),
              isEmailDetailEdited: false
            }, () => this.apiserve.success("Products updated successful."))
          }

          break;
        case "ticketCms|products|remove":
          this.props.history.push("/email-list");
          break;
        case "ticketCms|products|updateStatus":
          this.props.history.push("/email-list");
          break;
        case "ticketCms|products|globalSoldOut":
          if (response.error === false) {
            this.setState({ onSale: false, onSoldOut: response.data.globalSoldOut })
          }
          break;
      }
    });
  };

  getAllProductEditListdetails = () => {
    var templateId = this.props.EmailListEditId;
    this.apiserve.sendevent("email|getMailTemplate", { templateId });
  };

  deleteFilm = () => {
    this.setState({
      deleteFilm: true,
    });
  };

  soldOutFilm = () => {
    this.setState({
      onSale: !this.state.onSale,
    });
  };
  deleteFilmPopupYes = () => {
    this.apiserve.sendevent("ticketCms|products|remove", {
      productId: this.props.EmailListEditId,
    });
  };

  publishFilm = () => {
    this.setState({
      publishFilm: true,
    });
  };

  publishFilmPopupYes = () => {
    this.apiserve.sendevent("ticketCms|products|updateStatus", {
      productId: this.props.EmailListEditId,
      status: 1,
    });
  };

  disableFilm = () => {
    this.setState({
      disableFilm: true,
    });
  };
  soldOutFilm = () => {
    this.setState({
      onSale: !this.state.onSale,
    });
  };


  disableFilmPopupYes = () => {
    this.apiserve.sendevent("ticketCms|products|updateStatus", {
      productId: this.props.EmailListEditId,
      status: 2,
    });
  };

  discardPopupYes = () => {
    this.props.history.push({
      pathname: "/email-list"
    })
  }

  getMtTime = (date) => {
    //Get offset from mountain time using UTC
    //change 360 t0 420
    let ABBR = moment.tz("America/Denver").format("z");
    let offDifference = moment().utcOffset() + (ABBR === 'MDT' ? 360 : 420);
    // add that offset in date
    return moment(date).add(offDifference, 'minutes').toISOString()
  }

  submitFn = async (e) => {
    e.preventDefault();
    if (this.validator.allValid()) {
    this.setState({ loaderFlag: true });
    // if (this.state.changeCategoryTitleName) {
        const name = convertToRaw(this.state.summary.getCurrentContent());
        let summary = draftToHtml(name);
        if( summary === '<p></p>\n'){
            summary=''
        }
        console.log('this.state.summary',summary);
        
    let updateproducts = {
      subject: this.state.subject,
      content: summary,
      buttonColor: '',
      _id: this.props.EmailListEditId,
      title:this.state.title,
      previewText:this.state.previewText,
      pixelURL:this.state.pixelURL,
      localAppName:this.state.localAppName,
      fromEmail:this.state.fromEmail + '@sundance.org',
      emailTitle: this.state.emailTitle,
      isEmailEnabled: this.state.isEmailEnabled,
    };
    if(this.state.requiredButtonTitle){
        updateproducts = { 
            ...updateproducts,
            buttonTitle: this.state.buttonTitle,
        }
    }

    this.apiserve.sendevent("email|editMailTemplate", updateproducts);
    // }
    } else {
      this.validator.showMessages();
    }
  };

  validateModel = () => {
    this.setState({
      errorMsg: false,
    });
  };

  cancel = () => {
    this.setState({
      discardPopup: true
    })
  }
  onEditorStateChange = summary => {
    this.updateState({
      summary
    });
  };
  onEditorState = desc => {
    this.setState({
      desc
    });
  };
 


  render() {
    const { getLastUpdated } = this.state;
    var updateAt = new Date(getLastUpdated && getLastUpdated.updatedAt);
    var hour = moment(updateAt).format("h");
    var minutes = moment(updateAt).format("mm");
    var state = moment(updateAt).format("A");
    var updatedBy = getLastUpdated && getLastUpdated.updatedBy;
   
    return (
      <React.Fragment>
        <div className="right_side_wrapper">
          <ul className="fpg_admin_tab disp_flex">
            {this.state.data &&
              this.state.data.map((list, index) => {
                return (
                  <li className="active">
                    <p className="uppercase text_left">
                      {list.label}
                      <Link to="create-film">
                        <PlusIcon />
                      </Link>
                    </p>
                  </li>
                );
              })}
          </ul>

          <div className="back_date d_flex d_flex_align_center d_flex_justify_spacebt">
            <Link className="back_link" to="/email-list">
              {" "}
              <svg width="5" height="10" viewBox="0 0 5 10" fill="none">
                {" "}
                <path d="M5 0L0 5L5 10V0Z" fill="black" />{" "}
              </svg>{" "}
              Back to List
              </Link>
            <p className="update_date">
              Last Update: {hour}:{minutes} {state} -{" "}
              {moment(updateAt).format("MM/DD/YYYY")} Last Updated By:{" "}
              {updatedBy && updatedBy.fname} {updatedBy && updatedBy.lname}
            </p>
          </div>
          <div className="product_detail_content fpg_tabcontent pt_15">
            <form>
              <div className="product_wrap_content product_content_inner mt_15">
                <div className="product_form product_coupon_form d_flex">
                  <div className="product_form_left">
                  <div className="field_row horizontal_field product_access">
                      <TextField
                        type="text"
                        label="Template Identifier"
                        name="identifier"
                        value={this.state.identifier}
                        // disabled={true}
                        disable
                      // onChange={this.onInputChange}
                      />
                    </div>
                    <div className="field_row horizontal_field">
                        <TextField
                          type="text"
                        label="Template Title"
                        name="emailTitle"
                        value={this.state.emailTitle}
                        onChange={this.onInputChange}
                      />
                    </div>
                    <div className="field_row horizontal_field">
                      <TextField
                        type="text"
                        label="Template From Name"
                        name="localAppName"
                        value={this.state.localAppName}
                        onChange={this.onInputChange}
                      />
                    </div>
                    <div className="field_row horizontal_field">
                      <div class="field_row_inner">
                        <label class="null">Template From Email </label>
                          <div className="field_input relative">
                            <div className="email_field">
                            <input type="text" name="fromEmail" autocomplete="off" value={this.state.fromEmail} onChange={this.onInputChange} />
                            <span>@sundance.org</span>
                          </div>
                          <span style={{ color: 'red', display: 'block' }}> {this.validator.message('fromEmail', this.state.fromEmail, 'required')} </span>
                        </div>
                      </div>
                    </div>
                    <hr className="mt_25 mb_25"></hr>
                    <div className="field_row horizontal_field">
                      <div className="field_row_inner">
                          <label>Email Enabled</label>
                          <div className="relative mt_10">
                              <div className="checkbox_field_row">
                                  <div className="checkBox">
                                      <input
                                          type="checkbox"
                                          id="isEmailEnabled"
                                          name={`isEmailEnabled`}
                                          checked={this.state.isEmailEnabled}
                                          onChange={(e) => this.handleCheck(e)} />
                                      <label for="isEmailEnabled" style={{ width: "auto" }}></label>
                                  </div>
                              </div>
                          </div>
                      </div>
                    </div>
                    <div className="field_row horizontal_field">
                      <TextField
                        type="text"
                        label="Email Title"
                        name="title"
                        value={this.state.title}
                        onChange={this.onInputChange}
                      />
                    </div>
                    <div className="field_row horizontal_field">
                      <TextField
                        type="text"
                        label="Email Subject"
                        name="subject"
                        value={this.state.subject}
                        onChange={this.onInputChange}
                      />
                    </div>
                    <div className="field_row horizontal_field">
                      <TextField
                        type="text"
                        label="Email Preview Text"
                        name="previewText"
                        value={this.state.previewText}
                        onChange={this.onInputChange}
                      />
                    </div>
                    <div className="field_row horizontal_field">
                      <div className="field_row_inner">
                        <label>Email Content</label>
                        <div className="field_input relative">
                          <TextEditor
                            editorState={this.state.summary}
                            name="summary"
                            value={this.state.summary}
                            onEditorStateChange={this.onEditorStateChange}
                          />
                          {/* <textarea
                              name="summary"
                              value={this.state.summary}
                              rows="5"
                              onChange={this.onInputChange}
                            ></textarea> */}
                        </div>
                      {this.state.requiredKeys && this.state.requiredKeys?.length > 0 && 
                      <div style={{marginLeft:'10px'}}>
                        <p style={{color:'red'}}>Following keys can be included in Template content, Template Title and Template Subject.</p>
                        <ul style={{marginLeft:'10px',marginTop:'10px'}}>
                        {this.state.requiredKeys && this.state.requiredKeys?.length > 0 && this.state.requiredKeys?.map((item,i ) => {
                          return (
                            <li key={i} style={{color:'red'}}> {i+1}. {item} </li>
                          )
                        })}
                        </ul>
                      </div>}
                      </div>
                    </div>
                    
                    
                    {this.state.requiredButtonTitle && <div className="field_row horizontal_field">
                      <div className="field_row_inner">
                        <label>Email Button Title</label>
                        <div className="field_input relative">
                          <input
                            type="text"
                            name="buttonTitle"
                            value={this.state.buttonTitle}
                            disabled={false}
                            onChange={this.onInputChange}
                          />
                        </div>
                      </div>
                    </div>}
                    {/* <div className="field_row horizontal_field">
                      <div className="field_row_inner">
                        <label>Template Button Link</label>
                        <div className="field_input relative">
                          <input
                            type="text"
                            name="btnURL"
                            value={this.state.btnURL}
                            disabled={true}
                            onChange={this.onInputChange}
                          />
                        </div>
                      </div>
                    </div> */}
                    <div className="field_row horizontal_field product_access">
                      <TextField
                        type="text"
                        label="Email Button Link"
                        name="btnURL"
                        value={this.state.btnURL}
                        // disabled={true}
                        disable
                      // onChange={this.onInputChange}
                      />
                    </div>
                    <div className="field_row horizontal_field product_access">
                      <TextField
                        type="text"
                        label="Pixel URL"
                        name="pixelURL"
                        value={this.state.pixelURL}
                        // disabled={true}
                      onChange={this.onInputChange}
                      />
                    </div>
                    
                  </div>
                </div>
                <div className="product_actions">
                  
                </div>
              </div>
              <div className="text_center field_row w_100 buttons_outer">
                <button className="uppercase" onClick={e => this.cancel(e)} type="button">CANCEL</button>
                <button
                  className={`uppercase ${(!this.props.EmailListEditId || this.state.isEmailDetailEdited) ? 'active' : ''}`}
                  onClick={(e) => this.submitFn(e)}
                  disabled={this.state.loaderFlag || (this.props.EmailListEditId && !this.state.isEmailDetailEdited)}
                >
                  SAVE
                  </button>
              </div>
            </form>
          </div>
        </div>
        {this.state.deleteFilm ? (
          <PopUpCustomAll
            HeaderName="Delete?"
            insideDetails="You are about to delete an item and this action is permanent"
            insideData="Do you want to proceed?"
            popupState={this.closeAdminUser}
            yesPopUp={this.deleteFilmPopupYes}
          />
        ) : (
            ""
          )}
        {this.state.publishFilm ? (
          <PopUpCustomAll
            HeaderName="Publish Changes"
            insideDetails="Saving the current changes will publish it to the production site"
            insideData="Do you want to proceed?"
            popupState={this.closeAdminUser}
            yesPopUp={this.publishFilmPopupYes}
          />
        ) : (
            ""
          )}
        {this.state.disableFilm ? (
          <PopUpCustomAll
            HeaderName="Disable?"
            insideDetails="You are about to disable an item, which will temporarily make it unavailable on the production site"
            insideData="Do you want to proceed?"
            popupState={this.closeAdminUser}
            yesPopUp={this.disableFilmPopupYes}
          />
        ) : (
            ""
          )}
        {this.state.discardPopup ? (
          <PopUpCustomAll
            HeaderName="Discard Changes?"
            insideDetails="Leaving this page without saving will discard all changes"
            insideData="Do you want to proceed?"
            popupState={this.closeAdminUser}
            yesPopUp={this.discardPopupYes}
          />
        ) : (
            ""
          )}
        <div className={`user_popup ${this.state.errorMsg ? "active" : ""}`}>
          <span className="popup_overlay"></span>
          <div className="sundance_popup_detail box_shadow approve_success_popup bg_white">
            <div className="approve_popup_header text_center relative">
              <p>{this.state.errorMsgShow}</p>
            </div>
            <div className="content">
              <div className="field_row text_center">
                <button
                  className="small_btn active"
                  onClick={this.validateModel}
                >
                  OK
                </button>
              </div>
            </div>
          </div>
        </div>
        {this.state.loaderFlag ? <Loader /> : ""}
      </React.Fragment>
    );
  }
}

export default connect(mapStateToProps, null)(ProductDetail);